/*
 * Cookievore — "Try Me for Free" auto-add
 * Adds 1 Cereal Crunch to the cart, free, whenever any box is present.
 *
 * The 100% discount is applied by the Shopify automatic discount
 * "Try Me for Free — Cereal Crunch with any box".
 * This script ONLY puts the item in the cart. If it fails, the customer
 * simply doesn't get the gift — it can never sell a cookie at the wrong price.
 *
 * Toggle off with settings.cereal_gift_enabled = false in settings_data.json.
 */
(function () {
  'use strict';

  var CFG = {
    // Trigger = every product in the 'Boxes' collection (6s, 9s, bundles; incl. drafts).
    // Kept a SUBSET of the discount's collection trigger: if a box is added to the
    // collection later, the discount covers it and this list simply won't auto-add —
    // never the reverse, so we can't add a cookie that fails to discount.
    boxProductIds: [
      8503709204618, 8503709237386, 8514765455498, 8514765488266,
      8514765521034, 8514765553802, 8514765586570, 8514765619338,
      8514765652106, 8514765684874, 8514765717642, 8514765783178,
      8514765815946, 8514765881482, 8514765914250, 8514765947018,
      8514765979786, 8514766012554, 8514766045322, 8514766078090,
      8514766110858, 8514766143626, 8514766176394, 8514766209162,
      8514766241930, 8514766274698, 8514766307466, 8514766340234,
      8790660874378, 8864305184906
    ],
    giftVariantId: 50115054534794,
    giftName: 'Cereal Crunch',
    // must match the automatic discount's end date
    endsAt: '2026-09-06T20:59:59Z',
    prop: '_free_gift'
  };

  var running = false;
  var ADDED_KEY = 'cv_cc_gift_added';
  var DECLINED_KEY = 'cv_cc_gift_declined';

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function expired() { return Date.now() > Date.parse(CFG.endsAt); }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addGift() {
    var body = { id: CFG.giftVariantId, quantity: 1, properties: {} };
    body.properties[CFG.prop] = 'Free with any box';
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function setLineQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function cartHasBox(items) {
    return items.some(function (i) { return CFG.boxProductIds.indexOf(i.product_id) !== -1; });
  }

  /* Only ever touch a line WE added — never a Cereal Crunch the customer chose to buy. */
  function findGiftLine(items) {
    return items.filter(function (i) {
      return i.variant_id === CFG.giftVariantId && i.properties && i.properties[CFG.prop];
    })[0];
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (/\/cart/.test(window.location.pathname)) window.location.reload();
  }

  function toast(msg) {
    var el = document.getElementById('cv-gift-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cv-gift-toast';
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1a1a1a;' +
        'color:#fff;padding:13px 22px;border-radius:8px;font-size:14px;line-height:1.4;' +
        'z-index:99999;box-shadow:0 4px 16px rgba(0,0,0,.25);transition:opacity .3s;' +
        'max-width:92vw;text-align:center';
      document.body.appendChild(el);
    }
    el.innerHTML = msg;
    el.style.opacity = '1';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.opacity = '0'; }, 5000);
  }

  function sync() {
    if (running) return;
    running = true;
    getCart()
      .then(function (cart) {
        var hasBox = cartHasBox(cart.items);
        var gift = findGiftLine(cart.items);

        /* 1. No qualifying box -> pull our gift back out.
              Without this the discount stops applying and the customer
              would silently be charged full price for it. */
        if (gift && !hasBox) {
          return setLineQty(gift.key, 0).then(function () {
            store(ADDED_KEY, '');
            refreshCartUI();
          });
        }

        /* 2. Promo over -> stop adding (leave any existing line alone). */
        if (expired()) return;

        /* 3. Never more than one free one. */
        if (gift && gift.quantity > 1) {
          return setLineQty(gift.key, 1).then(refreshCartUI);
        }

        /* 4. Customer removed the gift themselves -> respect it, don't force it back. */
        if (hasBox && !gift && read(ADDED_KEY) === '1') {
          store(DECLINED_KEY, '1');
          return;
        }
        if (read(DECLINED_KEY) === '1') return;

        /* 5. Box present, no gift yet -> add it. */
        if (hasBox && !gift) {
          return addGift().then(function () {
            store(ADDED_KEY, '1');
            toast('🎁 <strong>' + CFG.giftName + '</strong> added free — our new cookie, on us. Ends Sunday.');
            refreshCartUI();
          });
        }
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  document.addEventListener('cart:item-added', sync);
  document.addEventListener('cart:updated', sync);

  /* Kalles posts cart changes over fetch/XHR — watch both so the drawer stays in step. */
  var _fetch = window.fetch;
  window.fetch = function (url) {
    var res = _fetch.apply(this, arguments);
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1) {
      res.then(function (r) { if (r.ok) setTimeout(sync, 350); return r; }).catch(function () {});
    }
    return res;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1)) {
      this.addEventListener('load', function () { setTimeout(sync, 350); });
    }
    return _open.apply(this, arguments);
  };

  if (document.readyState === 'complete') sync();
  else window.addEventListener('load', sync);
})();
